import '@resider/design-system/styles';
import { addTranslations, setLocale, setRoute } from '@resider/i18n';
import { createBrowserClient, createServerClient, isBrowser } from '@supabase/ssr'
import { env as envPublic } from '$env/dynamic/public'

export const load = async ({ data, depends, fetch, }) => {
  depends('supabase:auth');

  const supabase = isBrowser()
    ? createBrowserClient(envPublic.PUBLIC_SUPABASE_URL, envPublic.PUBLIC_SUPABASE_ANON_KEY, {
      global: {
        fetch,
      },
    })
    : createServerClient(envPublic.PUBLIC_SUPABASE_URL, envPublic.PUBLIC_SUPABASE_ANON_KEY, {
      global: {
        fetch,
      },
      cookies: {
        getAll() {
          return data.cookies
        },
      },
    })

  const {
    data: { session },
  } = await supabase.auth.getSession()

  const {
    data: { user },
  } = await supabase.auth.getUser()


  const { i18n, translations } = data;
  const { locale, route } = i18n;

  addTranslations(translations);

  await setRoute(route);
  await setLocale(locale);

  return {
    ...data,
    locale,
    route,
    session,
    supabase,
    user
  };
};
